import { logger } from "interfaces/logger";

import { supabase } from "./supabaseClient";

export type InterviewStyle = {
  accentColor: string;
  backgroundColor: string;
  logo: string;
  teamId: string;
};

export const findInterviewStyle = async (
  teamId: string
): Promise<undefined | InterviewStyle> => {
  const { data, error } = await supabase
    .from("interview_style")
    .select("*")
    .eq("team_id", teamId);

  if (error) {
    logger(error.message, "error");
    throw new Error(error.message);
  }

  // catch if there is no integration
  if (data.length === 0) {
    return undefined;
  }

  return {
    backgroundColor: data[0].background_color,
    accentColor: data[0].accent_color,
    logo: data[0].logo,
    teamId: data[0].team_id,
  };
};

export const upsertInterviewStyle = async (
  interviewStyle: InterviewStyle
): Promise<{ error?: string }> => {
  const { error } = await supabase.from("interview_style").upsert({
    accent_color: interviewStyle.accentColor,
    background_color: interviewStyle.backgroundColor,
    logo: interviewStyle.logo,
    team_id: interviewStyle.teamId,
  });

  return { error: error ? "Something went wrong when saving your styles" : "" };
};
